module.exports = __webpack_public_path__ + "app/home/home-2WKzHTYj.html";